<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_BookSubTitle" id="auto_bookmark_table_of_contents_1"><span>JUNE SCOBEE RODGERS PRESENTS</span></p>
<p class="P_WFP_BookSubTitle"><span><img alt="" id="TitleTexteBook" src="TitleTexteBook.jpg" style="max-width:100%; max-height:100%; "/></span></p>
<p class="P_WFP_By_Line__And__Bold"><span>Rebecca Moesta &amp; <br/>Kevin J. Anderson</span></p>
<p class="P_WFP_Copyright_Center"><span><span class="C_Current__And__No_Bold">Digital Edition - November 2014</span></span></p>
<p class="P_WFP_Copyright_Center"><span><span class="C_Current__And__No_Bold">WordFire Press<br/>www.wordfire.com</span></span></p>
<p class="P_WFP_Copyright_Center"><span>ISBN:  978-1-61475-108-3</span></p>
<p class="P_WFP_Copyright_Center"><span>Copyright © 2010 WordFire Inc and June Scobee Rodgers</span></p>
<p class="P_WFP_Copyright_left">All rights reserved. No part of this book may be reproduced or transmitted in any form or by any electronic or mechanical means, including photocopying, recording or by any information storage and retrieval system, without the express written permission of the copyright holder, except where permitted by law. This novel is a work of fiction. Names, characters, places and incidents are either the product of the author’s imagination, or, if real, used fictitiously.</p>
<p class="P_WFP_Copyright_left">This book is licensed for your personal enjoyment only. This ebook may not be re-sold or given away to other people. If you would like to share this book with another person, please purchase an additional copy for each recipient. Thank you for respecting the hard work of this author.</p>
<p class="P_WFP_Copyright_left"> </p>
<p class="P_WFP_Copyright_Center"><span>Cover Art by John E. Kaufmann </span></p>
<p class="P_WFP_Copyright_Center"><span>Logo Design by Matt Heerdt</span></p>
<p class="P_WFP_Copyright_left">The Star Challengers series created by June Scobee Rodgers, Rebecca Moesta and Kevin J. Anderson. All Rights Reserved. Challenger Center and the Challenger Center logo are registered trademarks and/or trademarks of Challenger Center in the United States and/or other countries. Published under license.</p>
<p class="P_WFP_Copyright_Center"><span>Book design by RuneWright LLC<br/>www.RuneWright.com </span></p>
<p class="P_WFP_Copyright_Center"><span>Published by<br/>WordFire Press, an imprint of<br/>WordFire, Inc.<br/>PO Box 1840<br/>Monument CO 80132 </span></p>
<p class="P_WFP_Copyright_Center"><span> </span></p>
<p class="P_WFP_Copyright_Center"><span><a href="http://www.challenger.org" target="_blank">www.challenger.org</a><br/>(Challenger Centers For Space Science Education) </span></p>
<p class="P_WFP_Copyright_Center"><span><a href="http://www.wordnre.com" target="_blank">www.wordfire.com</a><br/>(Explore the Universes of Kevin J. Anderson &amp; Rebecca Moesta) </span></p>
<p class="P_WFP_Copyright_Center"><span><a href="http://www.StarChallengers.com" target="_blank">www.StarChallengers.com</a></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?eefbb914